export const navLinks = [
  { label: '首页', path: '/' },
  { label: '产品服务', path: '/category' },
  { label: '新闻资讯', path: '/category?tab=news' },
  { label: '关于我们', path: '/about' },
];